import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { createClient, listClients } from "@/api/clients";

/** Os clientes do tenant (#1779), para a criação de projeto. */
export function useClients() {
  return useQuery({ queryKey: ["clients"], queryFn: listClients });
}

export function useCreateClient() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (name: string) => createClient(name),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["clients"] }),
  });
}
